export const thumbAdornment = {
  VIDEO: 'film',
  SERIES: 'roll',
  COLLECTION: 'roll',
};

export const itemType = {
  VIDEO: 'Vídeo',
  SERIES: 'Série',
  COLLECTION: 'Coleção',
};

export const HOME_SHOW_KEY_ID = 'home-show';

export const visibilities = {
  INTERNAL_USERS: 'Usuário interno',
  AUTHENTICATED_USERS: 'Usuário autenticado',
  EVERYONE: 'Todos',
};

export const visibilitiesColor = {
  INTERNAL_USERS: '#ff9d00',
  AUTHENTICATED_USERS: '#0048c3',
  EVERYONE: '#319300',
};

export const statusColor = {
  ARCHIVED: '#ff9d00',
  EXPIRED: '#FF2400',
  PUBLISHED: '#319300',
};
